import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import React from "react";

export interface IConfirmationDialog {
  cancelLabel?: string;
  description: string;
  confirmLabel?: string;
  heading: string;
  onProceed: () => void;
  open: boolean;
  handleClose: () => void;
}
export const ConfirmationDialog = ({
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  open,
  handleClose,
  description,
  heading,
  onProceed,
}: IConfirmationDialog) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{heading}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelLabel}</Button>
          <Button
            onClick={() => {
              onProceed();
              handleClose();
            }}
            autoFocus
          >
            {confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
